import { createContext } from "react";

const DF_MO0007Context = createContext();

export {DF_MO0007Context}